// API url based on environment
let apiUrl
let pageUrl

switch (process.env.ADENE_ENV) {
  case 'production':
    apiUrl = `https://api.poupaenergia.pt/api/v1`
    pageUrl = `https://api.poupaenergia.pt`
    break
  case 'qa':
    apiUrl = `https://teste.poupaenergia.pt/d/api/v1`
    pageUrl = `https://teste.poupaenergia.pt`
    break
  default:
    apiUrl = `https://teste.poupaenergia.pt/d/api/v1`
    pageUrl = `https://teste.poupaenergia.pt`
}

export const API_BASE_URL = apiUrl
export const SITE_URL = pageUrl



// WEBPACK FOOTER //
// ./src/config.js